import React, { useEffect, useState } from 'react';
import Layout from '@rezdy/components/Layout/DarkCentered';
import TextStyle from '@rezdy/components/TextStyle';
import { Title } from '../../components/SignUpV2/Styled';
import auth from '../../services/auth';
import Grid from '@rezdy/components/Grid';
import { Trans, WithTranslation, withTranslation } from 'react-i18next';
import { Article, Aside, Body } from '@rezdy/components/Layout/Article/Styled';
import SecondaryAction from '../../components/Layout/SecondaryAction';
import { ContactSupport } from '../../components/ContactSupport';
import { extractRequestParams } from './util';
import routing from '../../services/routing';
import routes from '../../constants/routes';
import { ChangeEmailError, ErrorCode } from './Errors';
import Loading from '../../components/Loading';
import { BookingSoftwareMarketingCard } from '../../components/BookingSoftwareMarketingCard';

export const ConfirmChangeEmail = ({ i18n, t, tReady }: WithTranslation) => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState<ErrorCode | null>(null);
    const [processing, setProcessing] = useState(true);

    useEffect(() => {
        const { code, username, newEmail } = extractRequestParams();

        if (!code || !username || !newEmail) {
            setError('INVALID_VERIFICATION_CODE');
            return;
        }
        setEmail(username);
        try {
            (async () => {
                try {
                    await auth.confirmChangeEmail({ code, username, newEmail });
                    setProcessing(false);
                } catch (e) {
                    switch (((error as unknown) as Error).message) {
                        case 'USER_NOT_LOGGED_IN':
                            routing.push(routes.SIGN_IN);
                            break;
                        case 'EXPIRED_REFRESH_TOKEN':
                        case 'INVALID_VERIFICATION_CODE':
                        case 'COGNITO_PROFILE_UPDATE_ERROR':
                            setError(((error as unknown) as Error).message as ErrorCode);
                            break;
                        default:
                            throw error;
                    }
                }
            })();
        } catch (e) {
            setError((e as Error).message as ErrorCode);
        }
    }, []);

    if (error) {
        return (
            <Layout secondaryAction={<SecondaryAction />}>
                <Article>
                    <Body>
                        <ChangeEmailError errorCode={error} email={email} i18n={i18n} t={t} tReady={tReady} />
                        <ContactSupport />
                    </Body>
                    <Aside>
                        <BookingSoftwareMarketingCard />
                    </Aside>
                </Article>
            </Layout>
        );
    }
    if (processing) {
        return (
            <Layout>
                <Loading />
            </Layout>
        );
    }

    return (
        <Layout secondaryAction={<SecondaryAction />}>
            <Article>
                <Body>
                    <Grid.Container rowGap="24px" style={{ maxWidth: 400 }}>
                        <Title>
                            <Trans i18nKey="title">
                                Almost done!
                                <br />
                                Verify your new email to complete the change
                            </Trans>
                        </Title>
                        <TextStyle as="p">
                            We&#39;ve sent a verification email to your new email.
                            <br />
                            Please verify your email.
                        </TextStyle>
                    </Grid.Container>
                </Body>
                <Aside>
                    <BookingSoftwareMarketingCard />
                </Aside>
            </Article>
        </Layout>
    );
};

export default withTranslation()(ConfirmChangeEmail);
